module.exports = __webpack_public_path__ + "media/images/question-4020aeec5fcdb4514419d1aaa4d4c4fe.png";